/* ============================================================
   Lupa de la ficha — recuadro sobre la carta + panel al lado

   El patrón es el de la referencia, y para un single es mejor que ampliar en
   el sitio: la carta se queda ENTERA y a la vista, un recuadro marca qué
   trozo estás mirando, y el detalle sale grande en un panel al lado. Ampliar
   encima tapa la carta, que es justo lo que no quieres cuando estás
   comprobando el estado y el centrado antes de pagar.

   Por qué no se usa la de Crave (magnify.js, ajuste image_zoom:'hover'): está
   mal llamada, se engancha a `image.onclick` y no al hover, y al ocupar el
   clic deja sin efecto el modal-opener, o sea que se pierde "ver la carta
   completa".
   ============================================================ */
(function () {
  'use strict';

  /* Sin cursor no hay recuadro que mover: en táctil manda el toque, que abre
     la carta completa. */
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var AUMENTO = 2.5;

  function mejorFuente(img) {
    var set = (img.getAttribute('srcset') || '').split(',');
    var mejor = { url: img.currentSrc || img.src, w: 0 };
    set.forEach(function (entrada) {
      var m = entrada.trim().match(/(\S+)\s+(\d+)w/);
      if (m && parseInt(m[2], 10) > mejor.w) mejor = { url: m[1], w: parseInt(m[2], 10) };
    });
    return mejor.url;
  }

  function tope(v, min, max) { return Math.max(min, Math.min(max, v)); }

  function activa(media) {
    if (media.dataset.tcgZoom) return;
    var img = media.querySelector('img');
    if (!img) return;
    media.dataset.tcgZoom = '1';

    /* Los eventos NO pueden ir en .product__media: Crave pone un
       .product__media-toggle (el disparador del lightbox) como hermano
       posterior que cubre la imagen entera, así que el puntero entra en el
       botón y el pointerenter de la imagen no se dispara nunca. Se escucha en
       el ancestro común y se mide contra la caja de la imagen. */
    var host = media.closest('.product__modal-opener') || media;
    var caja = media.closest('.product__media-wrapper') || host;

    var recuadro = document.createElement('span');
    recuadro.className = 'tcg-zoom__recuadro';
    recuadro.setAttribute('aria-hidden', 'true');
    media.appendChild(recuadro);

    var panel = document.createElement('span');
    panel.className = 'tcg-zoom__panel';
    panel.setAttribute('aria-hidden', 'true');
    caja.appendChild(panel);

    caja.classList.add('tcg-zoom');

    var listo = false;
    function prepara() {
      if (listo) return;
      listo = true;
      /* La fuente pesa (1946px de ancho). Pedirla al entrar el cursor dejaba
         el panel encendido mostrando nada durante el primer segundo, que se
         ve como "no hace zoom". Se precarga en cuanto el navegador está
         ocioso y una clase avisa de que ya está. */
      var url = mejorFuente(img);
      var previa = new Image();
      previa.onload = function () { caja.classList.add('tcg-zoom--listo'); };
      previa.src = url;
      panel.style.backgroundImage = 'url("' + url + '")';
    }

    function mueve(e) {
      var r = media.getBoundingClientRect();
      if (r.width < 10) return;
      var anchoR = r.width / AUMENTO;
      var altoR = r.height / AUMENTO;
      var x = tope(e.clientX - r.left - anchoR / 2, 0, r.width - anchoR);
      var y = tope(e.clientY - r.top - altoR / 2, 0, r.height - altoR);

      recuadro.style.width = anchoR + 'px';
      recuadro.style.height = altoR + 'px';
      recuadro.style.transform = 'translate(' + x + 'px,' + y + 'px)';

      /* El panel mide lo mismo que la carta, así que enseña exactamente el
         trozo que marca el recuadro, aumentado por AUMENTO. */
      panel.style.backgroundSize = r.width * AUMENTO + 'px ' + r.height * AUMENTO + 'px';
      panel.style.backgroundPosition = -x * AUMENTO + 'px ' + -y * AUMENTO + 'px';
    }

    host.addEventListener('tcg:precarga', prepara);
    host.addEventListener('pointerenter', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      prepara();
      mueve(e);
      /* Se marca siempre: que se vea o no lo decide el CSS, que exige además
         tcg-zoom--listo. Condicionarlo aquí dejaba la lupa muerta cuando el
         cursor llegaba antes de terminar la precarga, porque no vuelve a
         haber un pointerenter hasta salir y volver a entrar. */
      caja.classList.add('is-zoom');
    });
    host.addEventListener('pointermove', function (e) {
      if (!caja.classList.contains('is-zoom')) return;
      mueve(e);
    });
    host.addEventListener('pointerleave', function () {
      caja.classList.remove('is-zoom');
    });
    /* Al abrir el lightbox el cursor se va sin disparar pointerleave. */
    host.addEventListener('click', function () {
      caja.classList.remove('is-zoom');
    });
  }

  function arranca() {
    var medias = document.querySelectorAll('.tcg-pdp .product__media-wrapper .product__media');
    medias.forEach(activa);
    var precarga = function () {
      medias.forEach(function (m) {
        var h = m.closest('.product__modal-opener') || m;
        h.dispatchEvent(new Event('tcg:precarga'));
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(precarga, { timeout: 3000 });
    else setTimeout(precarga, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
  document.addEventListener('shopify:section:load', arranca);
})();
